import { useState, useEffect } from 'react';
import { theme } from '../styles/theme';

export const useResponsiveSidebar = () => {
  // Initialize sidebar state based on screen size
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    // Check if we're on mobile on initial load
    if (typeof window !== 'undefined') {
      return window.innerWidth >= parseInt(theme.breakpoints.lg);
    }
    return true; // Default to open for SSR
  });

  // Handle window resize to update sidebar state
  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < parseInt(theme.breakpoints.lg);
      // Close sidebar on mobile, keep current state on desktop
      if (isMobile) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    
    // Set initial state on mount
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const openSidebar = () => {
    setSidebarOpen(true);
  };

  return {
    sidebarOpen,
    toggleSidebar,
    closeSidebar,
    openSidebar,
  };
};
